export type BaseClientMethod = "DELETE" | "GET" | "POST" | "PUT" | "PATCH";

export enum HttpHeader {
	Accept = "Accept",
	Authorization = "Authorization",
	ContentDisposition = "Content-Disposition",
	ContentType = "Content-Type"
}